import api from "@/api";
import store from "@/store";

const resource = "ei/diario-escolar";

export default {
  getTurmas(data) {
    return api.get(`${resource}/turmas`, {
      params: {
        ...data,
        identificadorperfilatual: store.getters.userDadosPerfilAtual.identificadorperfil
      }
    });
  },
  getAulasProfessor(data) {
    return api.get(`${resource}/aulas`, {
      params: data
    });
  },
  getTurmaDisciplina(data) {
    return api.get(`${resource}/turma-disciplina-nome`, {
      params: data
    });
  },
  getGraficoAusencia(data) {
    return api.get(`${resource}/grafico-ausencia`, {
      params: data
    });
  },
  getAula(id) {
    return api.get(`${resource}/aula/${id}`);
  },
  postAula(data) {
    return api.post(`${resource}/aula`, data);
  },
  putAula(data) {
    return api.put(`${resource}/aula/${data.identificadoraula}`, data);
  },
  deleteAula(id) {
    return api.delete(`${resource}/aula/${id}`);
  },
  getListarAulas(data) {
    return api.get(`${resource}/aula`, {
      params: data
    });
  },
  getRangePeriodoAnoLetivo(data) {
    return api.get(`${resource}/range-periodo-ano-eletivo`, {
      params: data
    });
  },
  getListarAulasMes(data) {
    return api.get(`${resource}/aula-mes`, {
      params: data
    });
  },
  getListarAulasAEEouACPMes(data) {
    return api.get(`${resource}/aula-mes-aee-acp`, {
      params: data
    });
  },
  getTurmasPorDisciplinaProfessor(data) {
    return api.get(`${resource}/turmas-disciplina-professor`, {
      params: data
    });
  },
  setFrequancia(data) {
    return api.post(`${resource}/frequencia`, data);
  },
  postReplicarAulas(data) {
    return api.post(`${resource}/replicar-aulas`, data);
  },
  postReplicarAulasPorDisciplina(data) {
    return api.post(`${resource}/replicar-aulas-disciplina`, data);
  },
  getEnturmacaoNotas(data) {
    return api.get(`${resource}/enturmacao-notas`, {
      params: data
    });
  },
  saveListaNotas(data) {
    return api.post(`${resource}/save-lista-notas`, data);
  },

  setLancarNotas(data) {
    return api.post(`${resource}/lancar-notas`, data);
  },
  getPerfilTurma(data) {
    return api.get(`${resource}/perfilturma`, {
      params: data
    });
  },
  postPerfilTurma(data) {
    return api.post(`${resource}/perfilturma`, data);
  },
  getTotalizadorNotasFrequencia(data) {
    return api.get(`${resource}/totalizador-notas-frequencia`, {
      params: data
    });
  },
  getListarAlunosPDI(data) {
    return api.get(`${resource}/listar-alunos-pdi`, {
      params: data
    });
  },
  getListarAlunosDaTurma(data) {
    return api.get(`${resource}/listar-alunos-aee-acp`, {
      params: data
    });
  },
  getParecerDescritivo(data) {
    return api.get(`${resource}/parecer-descritivo`, {
      params: data
    });
  },
  getParecerDescritivoAEEouACP(data) {
    return api.get(`${resource}/parecer-descritivo-aee-acp`, {
      params: data
    });
  },
  postParecerDescritivo(data) {
    return api.post(`${resource}/parecer-descritivo`, data);
  },
  postParecerDescritivoAEEouACP(data) {
    return api.post(`${resource}/parecer-descritivo-aee-acp`, data);
  },
  deleteParecerDescritivo(id) {
    return api.delete(`${resource}/parecer-descritivo/${id}`, id);
  },
  deleteParecerDescritivoAEEouACP(id) {
    return api.delete(`${resource}/parecer-descritivo-aee-acp/${id}`, id);
  },
  getEnturmacaoConceito(data) {
    return api.get(`${resource}/enturmacao-conceito`, {
      params: data
    });
  },
  getAtividadeQualitativaTurma(data) {
    return api.get(`${resource}/listar-atividades-qualitativa-turma`, {
      params: data
    });
  },
  postLancarConceito(data) {
    return api.post(`${resource}/lancar-conceito`, data);
  },
  saveListaConceitosConceito(data) {
    return api.post(`${resource}/lancar-lista-conceito`, data);
  },
  cancelarDiario(data) {
      return api.post(`${resource}/cancelar-diario`, data);
  }
};
